
import { startViewTransition } from '@theme/utilities';
import { sectionRenderer } from '@theme/section-renderer';
const PagePagination = class extends HTMLElement {
    connectedCallback() {
        console.log(this.sectionId)
        if (this.hasAttribute('ajax')) {
            const links = this.querySelectorAll('a');
            links.forEach((link) => {
                link.addEventListener('click', (event) => {
                    this._onLinkClicked(event, link, this.sectionId);
                });
            });
        }
    }
    get sectionId() {
        const id = this.getAttribute('data-section-id');
        if (!id) throw new Error('Section ID is required');
        return id;
    }
    _onLinkClicked(event, target, sectionId) {
        event.preventDefault();
        const url = new URL(window.location.href);
        url.searchParams.set('page', target.getAttribute('data-page'));

        console.log(url.toString(), sectionRenderer);
        history.pushState(null, null, url.toString()); 
        startViewTransition(() => sectionRenderer.renderSection(sectionId), ['product-grid']);
    }
};
window.customElements.define('page-pagination', PagePagination);